import { useQueryParams } from 'setup-guide-components/hooks/history';
import enviro from 'enviro';
import { ENVIRO_USER_GUIDE_DEBUG_KEY, USER_GUIDE_DEBUG_MODE_QUERY_PARAM } from './debugConstants';
export const useDebugModeEnabled = () => {
  const queryParams = useQueryParams();
  return queryParams[USER_GUIDE_DEBUG_MODE_QUERY_PARAM] === 'enabled' || enviro.debug(ENVIRO_USER_GUIDE_DEBUG_KEY);
};